import { useI18n } from '@tribeplatform/react-components/i18n'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Input } from '@tribeplatform/react-ui-kit/Input'

export const FilterBar = ({ setFilters }) => {
  const { $t } = useI18n()
  return (
    <Card>
      <Card.Content>
        <Input
          leadingIcon={<SvgIcon name="search" />}
          onChange={e => setFilters({ query: e.target.value || undefined })}
          name="search"
          placeholder={$t({
            defaultMessage: 'Search {SPACES}...',
            id: 'Search.Spaces.Placeholder',
          })}
        />
      </Card.Content>
    </Card>
  )
}
